// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .custom-dropdown select {
    width: 250px;
    height: 40px;
    position: relative;
    top: 20px;
    left: 20px;
    color: black;
  }
  
  .custom-dropdown select option {
    background-color: white;
    color: black; /* Change text color if needed */
  }
  .calender{
    position: relative;
    left: 1000px;
    bottom: 25px;

  }
  input{
    border:  solid white;
  }
.Chartsdashboard-item {
  display: inline-block;
  width: 100;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 7px;
  margin: 4px;
  vertical-align: top;
  margin-left: 20px; /* Add margin to create a gap between items */
}

  
  .Chartsdashboard-item {
    display: inline-block;
    width: 100;
    box-sizing: border-box;
    border-radius: 10px;
    padding: 4px;
    margin: 2px;
    vertical-align: top;
  }
  
  
  .Chartsdashboard-item h6 {
    background-color: #116A7B;
    color: white; 
    padding: 5px;
    
  }
  
  .Chartsdashboard-item p {
    background-color: #E4F1FF;
    position: relative;
    bottom: 25px;
    text-align: center;
  }
  
  .chart1 {
    width: 700px;
    /* height: 360px; */
    background-color: white;
    position: relative;
    left: 20px;
    bottom: 30px;
  }
  
  .chart-heading {
    background-color: #116A7B;
    color: #E49393;
  }
  
  .horizontal-list {
    display: flex;
  }
  
  .horizontal-list li {
    margin-right: 15px; /* Decrease the margin to make the li elements smaller */
    position: relative;
    bottom: 30px;
    left: 25px;
    top: 2px;
    font-size: 14px; /* Adjust the font size */ /* Change the color of bullet points */
  }
  
  .bar-chart-container{
    position: relative;
    bottom: 20px;
    left: 40px;
  }

  .progressBar{
    width: 400px;
    /* height: 360px; */
    position: relative;
    left: 740px;
    bottom: 460px;
    background-color: white;
  }
  
  .progress-heading{
    background-color: #116A7B;
    color: #F55050;
  }

  .ProgressBar1{
    width: 95%;
    /* height: 90%; */
    position: relative;
    left: 20px;
  }
  .p-tag{
    position: relative;
    bottom: 60px;
    left: 20px;
  }
  .p-tag1{
    position: relative;
    bottom: 175px;
    left: 110px;

  }
  .p-tag2{
    position: relative;
    bottom: 132px;
    left: 200px;

  }


  .mapping{
    width: 420px;
    height: 300px;
    background-color: white;
    position: relative;
    bottom: 340px;
    left: 60px;
  }

  .mapping-header{
    background-color: #116A7B;
    position: relative;
    bottom: 22px;
  }

  .mapping-header1{
    position: relative;
    bottom: 30px;
  }
  .mapping-list{
    display: flex;
    margin-right: 50px; 
  }

  .image-properties{
    position: relative;
    bottom: 40px;
  }

  .Area-charts{
    background-color: white;
    width: 560px;
    /* height: 320px; */
    position: relative;
    left: 540px;
    bottom: 640px;
  }

  .Area-heading{
    background-color: #116A7B;
  }
  
  .horizontal-list{
    position: relative;
    top: 7px;
    
  }
  .area-graphs{
    position: relative;
    bottom: 20px;
    left: 40px;

  }

.graph-card{
  border-radius: 10px;
  border: none;
  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)
}

.card-info{
  text-align: center;
}
.row-data{
  position: relative;
  bottom: 54px;
}
.custom-padding-top{
  padding-top: 9px;
}

.custom-padding-right{
  padding-right: 15px;
}

.date-range{
  padding-top: 5px;
}
/* .highcharts-bold-text {
  font-weight: bold;
} */
.ant-calendar-range-picker-input{
  border-radius: 10px;
}
.ant-select-selection{
 
  border-radius: 20px;
  /* border: none; */
  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)
}
.anticon-calendar{
  width: 30px;
  position: absolute;
  top: -1px;
  right: -1px;
}
/* .ant-input{
  border-radius: 7px;
  border: none;
  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)
} */
.qms_real_tiem{
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-weight: 700;
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/modules/MIS/msi.css"],"names":[],"mappings":";EACE;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY,EAAE,gCAAgC;EAChD;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;;EAEd;EACA;IACE,oBAAoB;EACtB;AACF;EACE,qBAAqB;EACrB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB,EAAE,6CAA6C;AAClE;;;EAGE;IACE,qBAAqB;IACrB,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;;EAEd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB,EAAE,wDAAwD;IAC5E,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,eAAe,EAAE,yBAAyB,EAAE,sCAAsC;EACpF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;;EAEb;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;;EAEb;;;EAGA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;;EAEV;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;;EAEZ;;AAEF;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB;AACF;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;;;;GAIG;AACH;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["\r\n  .custom-dropdown select {\r\n    width: 250px;\r\n    height: 40px;\r\n    position: relative;\r\n    top: 20px;\r\n    left: 20px;\r\n    color: black;\r\n  }\r\n  \r\n  .custom-dropdown select option {\r\n    background-color: white;\r\n    color: black; /* Change text color if needed */\r\n  }\r\n  .calender{\r\n    position: relative;\r\n    left: 1000px;\r\n    bottom: 25px;\r\n\r\n  }\r\n  input{\r\n    border:  solid white;\r\n  }\r\n.Chartsdashboard-item {\r\n  display: inline-block;\r\n  width: 100;\r\n  box-sizing: border-box;\r\n  border-radius: 10px;\r\n  padding: 7px;\r\n  margin: 4px;\r\n  vertical-align: top;\r\n  margin-left: 20px; /* Add margin to create a gap between items */\r\n}\r\n\r\n  \r\n  .Chartsdashboard-item {\r\n    display: inline-block;\r\n    width: 100;\r\n    box-sizing: border-box;\r\n    border-radius: 10px;\r\n    padding: 4px;\r\n    margin: 2px;\r\n    vertical-align: top;\r\n  }\r\n  \r\n  \r\n  .Chartsdashboard-item h6 {\r\n    background-color: #116A7B;\r\n    color: white; \r\n    padding: 5px;\r\n    \r\n  }\r\n  \r\n  .Chartsdashboard-item p {\r\n    background-color: #E4F1FF;\r\n    position: relative;\r\n    bottom: 25px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .chart1 {\r\n    width: 700px;\r\n    /* height: 360px; */\r\n    background-color: white;\r\n    position: relative;\r\n    left: 20px;\r\n    bottom: 30px;\r\n  }\r\n  \r\n  .chart-heading {\r\n    background-color: #116A7B;\r\n    color: #E49393;\r\n  }\r\n  \r\n  .horizontal-list {\r\n    display: flex;\r\n  }\r\n  \r\n  .horizontal-list li {\r\n    margin-right: 15px; /* Decrease the margin to make the li elements smaller */\r\n    position: relative;\r\n    bottom: 30px;\r\n    left: 25px;\r\n    top: 2px;\r\n    font-size: 14px; /* Adjust the font size */ /* Change the color of bullet points */\r\n  }\r\n  \r\n  .bar-chart-container{\r\n    position: relative;\r\n    bottom: 20px;\r\n    left: 40px;\r\n  }\r\n\r\n  .progressBar{\r\n    width: 400px;\r\n    /* height: 360px; */\r\n    position: relative;\r\n    left: 740px;\r\n    bottom: 460px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .progress-heading{\r\n    background-color: #116A7B;\r\n    color: #F55050;\r\n  }\r\n\r\n  .ProgressBar1{\r\n    width: 95%;\r\n    /* height: 90%; */\r\n    position: relative;\r\n    left: 20px;\r\n  }\r\n  .p-tag{\r\n    position: relative;\r\n    bottom: 60px;\r\n    left: 20px;\r\n  }\r\n  .p-tag1{\r\n    position: relative;\r\n    bottom: 175px;\r\n    left: 110px;\r\n\r\n  }\r\n  .p-tag2{\r\n    position: relative;\r\n    bottom: 132px;\r\n    left: 200px;\r\n\r\n  }\r\n\r\n\r\n  .mapping{\r\n    width: 420px;\r\n    height: 300px;\r\n    background-color: white;\r\n    position: relative;\r\n    bottom: 340px;\r\n    left: 60px;\r\n  }\r\n\r\n  .mapping-header{\r\n    background-color: #116A7B;\r\n    position: relative;\r\n    bottom: 22px;\r\n  }\r\n\r\n  .mapping-header1{\r\n    position: relative;\r\n    bottom: 30px;\r\n  }\r\n  .mapping-list{\r\n    display: flex;\r\n    margin-right: 50px; \r\n  }\r\n\r\n  .image-properties{\r\n    position: relative;\r\n    bottom: 40px;\r\n  }\r\n\r\n  .Area-charts{\r\n    background-color: white;\r\n    width: 560px;\r\n    /* height: 320px; */\r\n    position: relative;\r\n    left: 540px;\r\n    bottom: 640px;\r\n  }\r\n\r\n  .Area-heading{\r\n    background-color: #116A7B;\r\n  }\r\n  \r\n  .horizontal-list{\r\n    position: relative;\r\n    top: 7px;\r\n    \r\n  }\r\n  .area-graphs{\r\n    position: relative;\r\n    bottom: 20px;\r\n    left: 40px;\r\n\r\n  }\r\n\r\n.graph-card{\r\n  border-radius: 10px;\r\n  border: none;\r\n  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)\r\n}\r\n\r\n.card-info{\r\n  text-align: center;\r\n}\r\n.row-data{\r\n  position: relative;\r\n  bottom: 54px;\r\n}\r\n.custom-padding-top{\r\n  padding-top: 9px;\r\n}\r\n\r\n.custom-padding-right{\r\n  padding-right: 15px;\r\n}\r\n\r\n.date-range{\r\n  padding-top: 5px;\r\n}\r\n/* .highcharts-bold-text {\r\n  font-weight: bold;\r\n} */\r\n.ant-calendar-range-picker-input{\r\n  border-radius: 10px;\r\n}\r\n.ant-select-selection{\r\n \r\n  border-radius: 20px;\r\n  /* border: none; */\r\n  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)\r\n}\r\n.anticon-calendar{\r\n  width: 30px;\r\n  position: absolute;\r\n  top: -1px;\r\n  right: -1px;\r\n}\r\n/* .ant-input{\r\n  border-radius: 7px;\r\n  border: none;\r\n  box-shadow: 0px 1px 8px rgb(23 110 222 / 10%)\r\n} */\r\n.qms_real_tiem{\r\n  writing-mode: vertical-rl;\r\n  text-orientation: mixed;\r\n  font-weight: 700;\r\n  transform: rotate(180deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
